import React, {
  ComponentPropsWithoutRef,
  ElementType,
  ForwardedRef,
  MouseEventHandler,
} from 'react';

import classNames from 'classnames';
import classes from './GridTableRow.module.scss';
import { PropsRewrite } from '../../../../utils-types';

type GridTableRowVariant =
  | 'header'
  | 'row'
  | 'compactRow'
  | 'subRow'
  | 'filter'
  | 'unstyled';

type GridTableRowProps<TComponent extends ElementType> = {
  variant: GridTableRowVariant;
  component?: TComponent;
  customLayout?: boolean;
  dataTestId?: string;
  highlight?: boolean;
  onClick?: MouseEventHandler<HTMLDivElement>;
  rootRef?: ForwardedRef<HTMLDivElement>;
  ref?: unknown;
};
// Uses the same styles as the elevated variant of <Surface />; we don't use Surface directly because its polymorphic generic is hard to type here.
// tableGridLayout used in table scss to add unique layout for all row
// TODO separate row size style and border/shadow (in or out of box )
// TODO add new size variant when 12px is left/right padding
const GridTableRow = <TComponent extends ElementType = 'div'>({
  children,
  variant,
  className,
  customLayout = false,
  highlight,
  dataTestId,
  onClick,
  rootRef,
  component,
  ...props
}: PropsRewrite<ComponentPropsWithoutRef<TComponent>, GridTableRowProps<TComponent>>) => {
  const Component: ElementType = component || 'div';

  const rowClasses = classNames(classes[variant], [classes.gridRow], className, {
    tableGridLayout: !customLayout,
    [classes.highlight]: highlight,
  });

  return (
    <Component
      ref={rootRef}
      className={rowClasses}
      data-test-id={dataTestId}
      onClick={onClick}
      {...props}
    >
      {children}
    </Component>
  );
};

export { GridTableRow, GridTableRowProps, GridTableRowVariant };
